export const INPUT_UNSET_VALUE = 'UNSET';

export enum EStepTitle {
  COMMENTS = 'Комментарий',
  PUBLISH = 'Параметры публикации',
}

export const stepIndex = {
    [EStepTitle.COMMENTS]: 0,
    [EStepTitle.PUBLISH]: 1,
};

export const SAVE_BUTTON_LABELS = {
    [EStepTitle.COMMENTS]: 'Сохранить',
    [EStepTitle.PUBLISH]: 'Опубликовать',
};
